import React from 'react';

const supported = new Set(['PA','CR','CO','GT','EC','MX','BR','ES']);
export default function CountryFlag({code}) {
  const country = String(code || '').toUpperCase();
  if (!supported.has(country)) return null;
  return <img className="loop-country-flag" src={`/assets/flags/${country.toLowerCase()}.svg`} alt="" aria-hidden="true" width="24" height="18"/>;
}
